import L from "../node_modules/leaflet"
import * as draw from "../node_modules/leaflet-draw"
import * as easy_button from "../node_modules/leaflet-easybutton"



/*******************/
/* Map definition */
/******************/

var map_char = L.map('map_charelements',{
  tap:false,
  'condensedAttributionControl':false
});


var topo_map_char = L.tileLayer('https://api.mapbox.com/styles/v1/mapesbasesigte/ckovcsddeeaat17p9eh6o2xvj/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoibWFwZXNiYXNlc2lndGUiLCJhIjoiY2s2Y2F4YnB5MDk4ZjNvb21rcWEzMHZ4NCJ9.oVtnggRtmtUL7GBav8Kstg', {
    maxZoom: 22,
    attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, ' +
      'Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
    id: 'mapbox/streets-v11',
    tileSize: 512,
    zoomOffset: -1
});


var hybrid_map_char = L.tileLayer('https://api.mapbox.com/styles/v1/mapesbasesigte/ckp6jjgds01c718n45c25lo97/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoibWFwZXNiYXNlc2lndGUiLCJhIjoiY2s2Y2F4YnB5MDk4ZjNvb21rcWEzMHZ4NCJ9.oVtnggRtmtUL7GBav8Kstg', {
    maxZoom: 22,
    attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, ' +
      'Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
    id: 'mapbox/streets-v11',
    tileSize: 512,
    zoomOffset: -1
});


var changeBasemapButton = L.easyButton({
  id: 'change-basemap',
  position: 'bottomleft',
  states: [{
            stateName: 'hybrid',        // name the state
            icon:      'fa-map',               // and define its properties
            //title:     'Hybrid Map',      // like its title
            onClick: function(btn, map) {       // and its callback
              $("#change-basemap").css("background-image", "url('"+min_topo_img+"')");
              map_char.removeLayer(topo_map_char)
              map_char.addLayer(hybrid_map_char)
              btn.state('topo');    // change state on click!
            }
        }, {
            stateName: 'topo',
            icon:      'fa-map',
            //title:     'Topographic Map',
            onClick: function(btn, map) {
              $("#change-basemap").css("background-image", "url('"+min_orto_img+"')");
              map_char.removeLayer(hybrid_map_char)
              map_char.addLayer(topo_map_char)
              btn.state('hybrid');
            }
    }]
});

changeBasemapButton.addTo(map_char);


// fit bounds to defined extent in questionnaire
var geojson_bbox = L.geoJson(bbox_pol);
map_char.fitBounds(geojson_bbox.getBounds());




/*************************************/
/* Load markers form current survey  */
/* This loads data when page refresh */
/*************************************/

var markers_char = new L.FeatureGroup();

recover_char_markers();



function recover_char_markers(){
  var ajax_recover_survey = $.ajax({
    type:"GET",
    datatype:'json',
    url: "/"+url_ajax_calls.prefix+"recover_survey_pk/"+q_num+"/"
  });


  ajax_recover_survey.done(function(data){
    if(data != 'error'){
      $.ajax({
        type:"GET",
        datatype: 'json',
        url: "/"+url_ajax_calls.prefix+"markers_char/"+data+"/",
        success: function(markers){
          markers_char.clearLayers();
          for(var i=0; i<markers.markers.length; i++){
            var p = L.geoJSON(markers.markers[i], {
              pointToLayer: function(feature, latlng){
                  var m = L.marker(latlng);
                  m.setIcon(editIcon);
                  return m;
                }
            }).bindPopup(function(layer){
              return layer.feature.geometry.properties.name;
            });

            markers_char.addLayer(p);

            // add class to selected items.
            markers.markers[i].properties.options.forEach(function(option, index){
              $( '.char_name_text'+option+'' ).removeClass( "text" ).addClass("option_marked");
            })

          }

          markers_char.addTo(map_char);
        }
      });
    }
  });
};


/*********************/
/* Draw items config */
/*********************/


var editIcon = new L.divIcon({
      html: '<i class="location-marker fas fa-map-marker-alt fa-5x" style="color:#4e7fff"></i>',
      //iconAnchor: new L.Point(26, 42),
      className: 'marker-icon',
      //iconSize: [10, 10]
      iconSize: [30, 30],
      iconAnchor: [10, 33]
    });

var toolbarIcon = new L.divIcon({
  html: '<i class="fas fa-map-marker-alt fa-5x" style="color:#red"></i>',
  iconAnchor: new L.Point(26, 42),
  className: 'marker-icon',
  iconSize: [10, 10]
});

var drawnItems = new L.FeatureGroup();

var drawControl = new L.Control.Draw({
  position: 'bottomright',
  draw: {
    polyline: false,
    polygon: false,
    circlemarker: false,
    circle: false,
    rectangle: false,
    marker: {
      icon: editIcon
    }
  },
  edit: {
    featureGroup: drawnItems,
    remove: false, // not show remove button
    edit: false   // not show edit button
  }
});

//https://github.com/Leaflet/Leaflet.draw/issues/265


map_char.addControl(drawControl);

// Controll events on edit
var last_marker_char;

map_char.on('draw:created', function(e){

  last_marker_char = e.layer;

  last_marker_char.addTo(map_char); // afegim el marcador al mapa

  if(e.layerType == 'marker'){
    var marker = L.circleMarker(e.layer._latlng);
    document.getElementById("geometry_char").value = JSON.stringify(marker.toGeoJSON());
  }

  $('#section1_charmap_modal').modal('open');

  $(window).scrollTop(0);
  event.preventDefault();

});


// on mobile devices, create a TOAST when start creating a feature.
if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
  map_char.on('draw:drawstart', function(e){
    var message = '<span>Click on the map to draw a place</span>';
    M.toast({html: message});

    $(".leaflet-draw-toolbar a").css({opacity:0.5});
  });
}



// remove marker when click on cancel button
$('.cancel_marker_char').click(function(){
  document.getElementById('char_name_modal').value = '';
  document.getElementById("section1_char_elements_form").reset(); // clear form
  map_char.removeLayer(last_marker_char);

  $('html, body').stop().animate({
    scrollLeft: $('#section1_char_elements').offset().left
  }, 1000);
  $(window).scrollTop(0);

});

// enter a new item
$('.new_item_char').click(function(e){
  var name = $("#char_name_modal").val();

  document.getElementById("char_name").value = name;

  last_marker_char.bindPopup(name); // add the name to the popup

  /* add data with ajax */
  e.preventDefault();

  var selected_options = $('#section1_char_elements :checked');
  var selected_options_array = []

  var $inputs = $('#section1_char_elements :input');
  var geom;
  var char_name;


  for(var i=0; i<$inputs.length; i++){

    if ($inputs[i].name == 'geometry_char'){
       geom = $inputs[i];
    };

    if ($inputs[i].name == 'char_name'){
       char_name = $inputs[i];
    };
  }

  for(var i=0; i<selected_options.length; i++){
    selected_options_array.push(selected_options[i].value);
  }

  // add class to selected items.
  selected_options_array.forEach(function(option, index){
    $( '.char_name_text'+option+'' ).removeClass( "text" ).addClass("option_marked");
  })


  if(char_name.value.length > 0){

    $('.error_name_charmap').addClass('hidden'); // hide error message

    var ajax_create_marker = $.ajax({
      type: "POST",
      url: "/"+url_ajax_calls.prefix+"char_form_submit/"+q_num+"/",
      data:{
        name: char_name.value,
        coordinates: JSON.parse(geom.value).geometry.coordinates,
        selected_options: selected_options_array,
        datatype: "json",
        csrfmiddlewaretoken:$('input[name=csrfmiddlewaretoken]').val(),
      }
    });

    var ajax_recover_survey = $.ajax({
      type:"GET",
      datatype:'json',
      url: "/"+url_ajax_calls.prefix+"recover_survey_pk/"+q_num+"/"
    });

    ajax_create_marker.done(function(data){
      if( $(e.target).hasClass('advance')){

        ajax_recover_survey.done(function(survey_pk){
          $.ajax({
            type: "GET",
            url: "/"+url_ajax_calls.prefix+"validate_char_elements/"+q_num+"/"+survey_pk+"/",
            success: function(validated){
              if(validated.msg == "error"){
                $('.charmap_validation').removeClass('hidden');

                $.ajax({
                  type: "GET",
                  datatype: 'json',
                  url: "/"+url_ajax_calls.prefix+"delete_last_char_marker/"+survey_pk+"/"
                });

              }else{
                document.getElementById('char_name_modal').value = '';
                document.getElementById("section1_char_elements_form").reset(); // clear form
                $('#section1_charmap_modal').modal('close'); // this close the modal

                slideNexPageAfterMap('#section1_char_elements', '#section1_charelementsmap', '#section1_positive');

                $('html, body').stop().animate({
                  scrollLeft: $("#section1_positive").offset().left
                }, 1000);
                $(window).scrollTop(0);
              }

            }
          });
        });

      }else{
        document.getElementById('char_name_modal').value = '';
        document.getElementById("section1_char_elements_form").reset(); // clear form

        $('#section1_charmap_modal').modal('close'); // this close the modal

        validate_char_section(); // if page is validated, continue button is not disabled
        $('.error_name_charmap').addClass('hidden');

        $('html, body').stop().animate({
          scrollLeft: $('#section1_char_elements').offset().left
        }, 1000);
        $(window).scrollTop(0);
      }
    });

  }else{
    $('.error_name_charmap').removeClass('hidden');
  };


});




/*************************/
/* Validations for map   */
/*************************/

$('.go_to_map_char_elements').click(function(e){
  //markers_char.clearLayers();
  //recover_char_markers();

  // on mobile, reset opacity of button
  if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
    $(".leaflet-draw-toolbar a").css({opacity:1});
  };


  var $inputs = $('#section1_char_elements_form :checked');
  if($inputs.length > 0){

    $('body').css('width', '200vw');
    $('#section1_charelementsmap').removeClass('hidden');

    $('.error_select_char').addClass('hidden');

    setTimeout(function(){
      recover_char_markers();
      map_char.invalidateSize();
      map_char.fitBounds(geojson_bbox.getBounds());
      topo_map_char.addTo(map_char);

      // set max bounds. Don' allow user to pan over this bounds
      map_char.setMaxBounds(geojson_bbox.getBounds());
      // get initial map zoom
      var zoom_char = map_char.getZoom();
      // set max zoom
      map_char.setMinZoom(zoom_char);
    }, 0.1);

    $('html, body').stop().animate({
      scrollLeft: $("#section1_charelementsmap").offset().left
    }, 1000);
    $(window).scrollTop(0);
    event.preventDefault();

  }else{
    $('.error_select_char').removeClass('hidden');
    //alert('select at least one option');
  }
});

// validation to go to next section from questionnaire page
// at least 1 element per category

$('.validate_char_section').click(function(e){
  
  var ajax_recover_survey = $.ajax({
    type:"GET",
    datatype:'json',
    url: "/"+url_ajax_calls.prefix+"recover_survey_pk/"+q_num+"/"
  });

  ajax_recover_survey.done(function(survey_pk){
    $.ajax({
      type: "GET",
      url: "/"+url_ajax_calls.prefix+"validate_char_elements/"+q_num+"/"+survey_pk+"/",
      success: function(validated){
        if(validated.msg == "error"){
          alert('Enter all the items!')

        }else{
          map_char.remove()
          slideNexPageAfterMap('#section1_char_elements', '#section1_charelementsmap', '#section1_positive');

          $('html, body').stop().animate({
            scrollLeft: $("#section1_positive").offset().left
          }, 1000);
          $(window).scrollTop(0);
        }
      }
    });
  })

});

function validate_char_section(){

  var ajax_recover_survey = $.ajax({
    type:"GET",
    datatype:'json',
    url: "/"+url_ajax_calls.prefix+"recover_survey_pk/"+q_num+"/"
  });

  ajax_recover_survey.done(function(survey_pk){
    $.ajax({
      type: "GET",
      url: "/"+url_ajax_calls.prefix+"validate_char_elements/"+q_num+"/"+survey_pk+"/",
      success: function(validated){
        if(validated.msg == "OK"){
          $('.validate_char_section').removeClass('disabled');
        }
      }
    });
  })

};


/***********************/
/*    Translate texts  */
/*                     */
/**********************/

$('.leaflet-control-zoom-in').attr('title', leaflet_texts[0]);
$('.leaflet-control-zoom-out').attr('title', leaflet_texts[1]);
$('.leaflet-draw-draw-marker').attr('title', leaflet_texts[2]);
